module.exports = __webpack_public_path__ + "img/printer.588ec9b1.svg";